//gravity forms
$( document ).on( 'gform_confirmation_loaded', function() {
	const lienDownloadPdf = document.getElementById( 'gform-download-pdf' );
	if ( lienDownloadPdf ) {
		lienDownloadPdf.click();
	}
} );